import AuthService from "../login/auth.service";
import { comprobantes, basaSipacoop,dimo } from "../../components/generico/utils/UrlAPI";
import axios from "axios";
//servicio
class TransferInterentidadService {
  async getCuentasExternas() {

    var config = {
      method: "get",
      url: basaSipacoop + "cuentasdestinos/v2/cedula",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken()
      }
    };

    return await axios(config);
  }

  async getEntidades() {
    var config = {
      method: "get",
      url: basaSipacoop + "entidades/v2",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken()
      }
    };

    return await axios(config);
  }

  async getTiposDocumentos() {
    var config = {
      method: "get",
      url: basaSipacoop + "tiposdocumentos",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken()
      }
    };

    return await axios(config);
  }
  async getTiposAlias() {
    var config = {
      method: "get",
      url: dimo + "alias/tipo-alias",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken()
      }
    };

    return await axios(config);
  }

  async addCuentaExterna(
    nombreDestino,
    ctaDestino,
    tipoDocumento,
    nroDocDestino,
    entidad,
    alias,
    tipoAlias
  ) {
    var data = JSON.stringify({
      cedulaSocio: AuthService.getSocio().numeroCedula,
      nombreDestino: nombreDestino,
      tipoCuenta: "EXTERNA",
      cuentaDestino: ctaDestino,
      entidad: { id: entidad },
      tipoDocumento: { id: tipoDocumento },
      numeroDocumentoDestino: nroDocDestino,
      alias:alias,
      tipoAlias:tipoAlias
    });
    var config = {
      method: "post",
      url: basaSipacoop + "cuentasdestinos",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken()
      },
      data: data,
    };

    return await axios(config);
  }

  async getDatosAlias(alias,tipoAlias) {
    
    var config = {
      method: "get",
     // http://cu24-dimo-cu24hs-dev.apps.okd4prd.cu.coop.py/alias/consultar?alias=5100159&tipoAlias=CI
     // url: cuentas + "simulador/ahorros-disponibles?idMoneda=" + idMoneda + '&plazoMaximo='+ plazos + '&monto=' + monto,
     url: dimo + "alias/consultar?alias=" + alias + '&tipoAlias='+ tipoAlias ,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken()
      }
    };
  
    return await axios(config);
  }


  async deleteCuentaExterna(dato) {
    var config = {
      method: "delete",
      url: basaSipacoop + "cuentasdestinos/" + dato,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken()
      },
    };

    return await axios(config);
  }
  

  async confirmarTransferenciaInterbancaria(
    importe,
    moneda,
    motivo,
    ctaOrigen,
    tipoDocOrigen,
    nombreOrigen,
    codEntidad,
    ctaDestino,
    tipoDocDestino,
    docDestino,
    nombreDestino,
    pinTransaccional,
    destinatario,
    intermediario,
    alias,
    entidadDatosAlternativos,
    transferenciaDatosRepetidos
  ) {
    var data = JSON.stringify({
      importe: importe,
      moneda: moneda,
      motivo: motivo,
      cuentaOrigen: ctaOrigen,
      tipoDocumentoOrigen: tipoDocOrigen,
      documentoOrigen: AuthService.getSocio().numeroCedula,
      nombreOrigen: nombreOrigen,
      codigoEntidad: codEntidad,
      cuentaDestino: ctaDestino,
      tipoDocumentoDestino: tipoDocDestino,
      documentoDestino: docDestino,
      nombreDestino: nombreDestino,
      pinTransaccional: pinTransaccional,
      canal: "WEB",
      codDestinatario: destinatario,
      intermediario: intermediario,
      alias:alias,
      telefonoDestino: "",
      entidadDatosAlternativos,
      transferenciaDatosRepetidos
    });

    var config = {
      method: "post",
      url: basaSipacoop + "transferencias/v2/enviar",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken()
      },
      data: data,
      timeout: 120000,
    };

    return await axios(config);
  }

  async descagarComponente(
    _titulo,
    _nroOperacion,
    _cuentaTitular,
    _tipo,
    _moneda,
    _cuentaDebito,
    _cuentaCredito,
    _importeDebito,
    _importeCredito,
    _titularCuentaDestino,
    _entidad,
    _tipoDocDestino,
    _documentoDestino,
    _motivo
  ) {
    var data = JSON.stringify({
      titulo: _titulo,
      nroOperacion: _nroOperacion,
      cuentaTitular: _cuentaTitular,
      tipo: _tipo,
      moneda: _moneda,
      cuentaDebito: _cuentaDebito,
      cuentaCredito: _cuentaCredito,
      importeDebito: _importeDebito,
      importeCredito: _importeCredito,
      titularCuentaDestino: _titularCuentaDestino,
      entidad: _entidad,
      tipoDocDestino: _tipoDocDestino,
      documentoDestino: _documentoDestino,
      motivo: _motivo
    });

    var _url = comprobantes + "comprobantes/v2/transferencias-interbancarias";

    var config = {
      method: "POST",
      url: _url,
      data: data,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
    };
    return await axios(config);
  }
}
export default new TransferInterentidadService();
